import zhCN from "./locales/zh-CN.json";
import zhTW from "./locales/zh-TW.json";
import enUS from "./locales/en-US.json";
import jaJP from "./locales/ja-JP.json";
import koKR from "./locales/ko-KR.json";

export const LOCALES = {
  "zh-Hans": { code: "zh-CN", prefix: "", label: "简体中文" },
  "zh-Hant": { code: "zh-TW", prefix: "zh-tw", label: "繁體中文" },
  en: { code: "en-US", prefix: "en", label: "English" },
  ja: { code: "ja-JP", prefix: "ja", label: "日本語" },
  ko: { code: "ko-KR", prefix: "ko", label: "한국어" },
};

export const MESSAGES = {
  "zh-Hans": zhCN,
  "zh-Hant": zhTW,
  en: enUS,
  ja: jaJP,
  ko: koKR,
};

export function t(locale, key, fallback = "") {
  const messageByLocale = MESSAGES[locale];
  if (
    messageByLocale &&
    Object.prototype.hasOwnProperty.call(messageByLocale, key)
  ) {
    return messageByLocale[key];
  }

  if (Object.prototype.hasOwnProperty.call(zhCN, key)) {
    return zhCN[key];
  }

  if (Object.prototype.hasOwnProperty.call(enUS, key)) {
    return enUS[key];
  }

  return fallback || key;
}

export function localeByPrefix(prefix = "") {
  if (!prefix) return "zh-Hans";
  const hit = Object.entries(LOCALES).find(
    ([, info]) => info.prefix === prefix,
  );
  return hit ? hit[0] : "zh-Hans";
}

export function prefixByLocale(locale = "zh-Hans") {
  return LOCALES[locale]?.prefix || "";
}
